<div
  class="banner-headline"
  [ngStyle]="headlineStyle">
  <ng-content></ng-content>
</div>
